import React, { useEffect, useState } from 'react';
import { _$, _addClass, _removeClass, _setText } from '../../../controllers/dom';
import { locales } from '../../../translations/locales';
import { BsClipboardPlus } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import { NotificationManager } from 'react-notifications';
import events from '../../../events';
import Loading from '../../Loading';

const GameInformations = (props) => {
    const { theme, locale, data, ModuleRP } = props;
    const [isPublic, setIsPublic] = useState(data.isPublic);
    const [recruitmentOpen, setRecruitmentOpen] = useState(data.recruitmentOpen);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const updateConfigAccess = () => {
        ModuleRP.config.access(isPublic, recruitmentOpen);
    };
    const copyClipboard = () => {
        navigator.clipboard.writeText(data.invitationCode)
            .then(() => {
                NotificationManager.success(locales[locale].notifications.copySuccess, '', 3000);
            })
            .catch(() => {
                NotificationManager.error(locales[locale].notifications.copyError, '', 3000);
            });
    };
    useEffect(() => {
        if (data.type !== 'game') {
            ModuleRP.socket.emit(events.CONFIGURE, ModuleRP.gameId);
        } else {
            _removeClass('publicGame', [(theme === 'DARK' ? 'btn-light' : 'btn-dark'), 'btn-danger', 'btn-success']);
            _removeClass('recruitmentGame', [(theme === 'DARK' ? 'btn-light' : 'btn-dark'), 'btn-danger', 'btn-success']);
            _$('btn-confirm-update-infos').disabled = false;
            _$('btn-confirm-update-access').disabled = false;
            _setText('btn-confirm-update-infos', locales[locale].config.update);
            _setText('btn-confirm-update-access', locales[locale].config.update);
            if (isPublic) {
                _addClass('publicGame', 'btn-success');
                _setText('publicGame', locales[locale].yes);
            } else {
                _addClass('publicGame', 'btn-danger');
                _setText('publicGame', locales[locale].no);
            }
            if (recruitmentOpen) {
                _addClass('recruitmentGame', 'btn-success');
                _setText('recruitmentGame', locales[locale].yes);
            } else {
                _addClass('recruitmentGame', 'btn-danger');
                _setText('recruitmentGame', locales[locale].no);
            }
        }
    }, [recruitmentOpen, isPublic, locale, theme, data]);

    return (
        data.type === 'game' ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">{locales[locale].config.gameInfosTitle}</h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <h5 className="card-title">{locales[locale].config.gameNameTitle}</h5>
                        <input type='text' className='form-control' id='gameName' placeholder={data.name} defaultValue={data.name} maxLength={35} />
                        <p className="card-text text-secondary">{locales[locale].config.gameNameInfos}</p>
                        <h5 className="card-title">{locales[locale].config.gameDescriptionTitle}</h5>
                        <input
                            type='text'
                            className='form-control'
                            id='gameDescription'
                            placeholder={data.description}
                            defaultValue={data.description}
                            maxLength={150}
                        />
                        <p className="card-text text-secondary">{locales[locale].config.gameDescriptionInfos}</p>
                        <h5 className="card-title">{locales[locale].config.apiKey}</h5>
                        <div className="card-text text-secondary">
                            <span className={`text-${theme === 'DARK' ? 'light' : 'dark'}`}>
                                {data.id}
                            </span>
                            <span
                                className={`text-${theme === 'DARK' ? 'light' : 'dark'} m-1 cursor-pointer`}
                                data-tip data-tooltip-id='apiKey'
                                onClick={copyClipboard}
                            >
                                <BsClipboardPlus />
                                <Tooltip id='apiKey' place='top' effect='solid' className='text-center'>
                                    {locales[locale].config.copyClipboard}
                                </Tooltip>
                            </span>
                        </div>
                        <button
                            type='button' id='btn-confirm-update-infos' className="btn btn-primary float-right" onClick={ModuleRP.config.infos}>
                            {locales[locale].config.update}
                        </button>
                    </div>
                </div>
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">{locales[locale].config.options}</h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <div className="row">
                            <div className="col-sm-8">
                                <h5 className="card-title">SIG - Système d&apos;Information Géographique</h5>
                                <p className="card-text text-secondary">{data.options.sig.active ? 'Actif' : 'Non actif'}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card container p-0 gameInformations mt-5 mb-2">
                    <h5 className="card-header bg-primary">{locales[locale].config.gameAccessTitle}</h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <div className="row">
                            <div className="col-sm-8">
                                <h5 className="card-title">{locales[locale].config.gamePublicTitle}</h5>
                            </div>
                            <div
                                className={`col h-25 btn btn-sm btn-${theme === 'DARK' ? 'light' : 'dark'}`}
                                id="publicGame"
                                onClick={() => setIsPublic(isPublic ? false : true)}
                            >
                                {locales[locale].loading}
                            </div>
                            <div className="card-text text-secondary">
                                {locales[locale].config.gamePublicInfos}
                                <span className={`text-${theme === 'DARK' ? 'light' : 'dark'}`}>
                                    {data.invitationCode}
                                </span>
                                <span
                                    className={`text-${theme === 'DARK' ? 'light' : 'dark'} m-1 cursor-pointer`}
                                    data-tip data-tooltip-id='copy'
                                    onClick={copyClipboard}
                                >
                                    <BsClipboardPlus />
                                    <Tooltip id='copy' place='top' effect='solid' className='text-center'>
                                        {locales[locale].config.copyClipboard}
                                    </Tooltip>
                                </span>
                            </div>
                        </div>
                        <hr className={`m-1 bg-secondary`} />
                        <div className="row mt-1">
                            <div className="col-sm-8">
                                <h5 className="card-title">{locales[locale].config.gameRecruitmentTitle}</h5>
                            </div>
                            <div
                                className={`col h-25 btn btn-sm btn-${theme === 'DARK' ? 'light' : 'dark'}`}
                                id="recruitmentGame"
                                onClick={() => setRecruitmentOpen(recruitmentOpen ? false : true)}
                            >
                                {locales[locale].loading}
                            </div>
                            <p className="card-text text-secondary">{locales[locale].config.gameRecruitmentInfos}</p>
                        </div>
                        <button type='button' id='btn-confirm-update-access' className="btn btn-primary float-right" onClick={updateConfigAccess}>
                            {locales[locale].config.update}
                        </button>
                    </div>
                </div>
                <div className="card container p-0 gameInformations mt-5 mb-2">
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <div className="row">
                            <div className="col-sm-8"></div>
                            <div className='col h-25 btn btn-danger' onClick={() => setConfirmDelete(true)}>
                                {locales[locale].config.delete}
                            </div>
                        </div>
                        <div className={confirmDelete ? '' : 'hide'} id="deleteGame">
                            <hr className={`m-1 bg-secondary`} />
                            <div>
                                {locales[locale].config.deleteConfirm}
                            </div>
                            <div className="text-center">
                                <button className='btn btn-sm btn-secondary w-25 m-3' onClick={() => setConfirmDelete(false)}>
                                    {locales[locale].no}
                                </button>
                                <button className='btn btn-sm btn-danger w-25 m-3' id='btn-delete-game' onClick={ModuleRP.config.deleteGame}>
                                    {locales[locale].yes}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default GameInformations;
